export const BOLD_REGEX = /\*\*(.*?\*?)\*\*/g;
export const ITALIC_REGEX = /\*(.*?)\*/g;
export const VAR_REGEX = /{}/g;
export const LINE_THROUG_REGEX = /~~(.*?)~~/g;
export const MONOSPACE_REGEX = /`(.*?)`/g;
export const LINK_LIKE_REGEX = /\[(.*?)\]\((.*?)\)/g;
export const INTERNAL_LINK_REGEX = /\[([\w\sÀ-ž,.?!]*)\]\(doxxbet:(.*?)\)/g;
export const EXTERNAL_LINK_REGEX =
  /\[(.*?)\]\(((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w/]*))?)\)/g;

export function formatSpecialString(text: string): string {
  let counter = 0;
  text
    .replaceAll(BOLD_REGEX, '<span class="label_bold label-bold">$1</span>')
    .replaceAll(
      ITALIC_REGEX,
      '<span class="label_italic label-italic">$1</span>'
    )
    .replaceAll(
      VAR_REGEX,
      () =>
        `<span class="label_var label-var var${counter}">${
          arguments[1][counter++]
        }</span>`
    )
    .replaceAll(
      LINE_THROUG_REGEX,
      '<span class="label_line_throug label-line-throug">$1</span>'
    )
    .replaceAll(
      MONOSPACE_REGEX,
      '<span class="label_monospace label-monospace">$1</span>'
    )
    .replaceAll(
      INTERNAL_LINK_REGEX,
      (_match, group1, group2) =>
        `
            <a
              href="${group2}"
              onclick="window.fakeRouterLink(event)"
              class="label_link label-link"
            >
              ${group1}
            </a>
          `
    )
    .replaceAll(
      EXTERNAL_LINK_REGEX,
      `<a target="_blank" href="$2" class="label_link label-link" >$1</a>`
    )
    .replaceAll(LINK_LIKE_REGEX, `<span class="label_$2">$1<span>`);
  return text;
}
